import { SelectComponent } from "@/components/select/Select";
import { Grid, GridItem } from "@chakra-ui/react";
import { InputField } from "@/components/input-field/InputField";
import { Trash2 } from "lucide-react";
import { Control, FieldArrayWithId } from "react-hook-form";
import { FuelSlotRequestCreationForm } from "../../schema/fuel-slot-requests.schema";
import { numbersWithCommaDecimal } from "@/utils/reg-expressions";
import { handleTonChangeInInput } from "@/utils/query-string";

interface Props {
  control: Control<FuelSlotRequestCreationForm>;
  idx: number;
  f: FieldArrayWithId<any, "productos", "id">;
  productItems: any[];
  loadingProducts: boolean;
  fields: FieldArrayWithId<any, "productos", "id">[];
  remove: (index: number) => void;
  disabled?: boolean;
}

export const FuelRequestProductElement = ({
  control,
  idx,
  f,
  productItems,
  loadingProducts,
  fields,
  remove,
  disabled,
}: Props) => {
  return (
    <Grid key={f.id} templateColumns="repeat(6, 1fr)" gap={6} alignItems="end">
      <GridItem colSpan={4}>
        <SelectComponent
          fullWidth
          name={`productos.${idx}.idProducto`}
          control={control as any}
          labelText="Producto"
          placeholder="Seleccionar"
          items={productItems as any}
          loading={loadingProducts}
          disabled={loadingProducts || disabled}
          closeOnSelect
          clearable
          size="xs"
          minHeight="40px"
        />
      </GridItem>

      <GridItem colSpan={1}>
        <InputField
          inputName={`productos.${idx}.cantidad`}
          labelText="Ingresar litros"
          placeholder="Ingresar"
          control={control as any}
          type="text"
          allowedPattern={numbersWithCommaDecimal}
          onChange={handleTonChangeInInput}
          minHeight="40px"
          disabled={disabled}
        />
      </GridItem>

      <GridItem colSpan={1}>
        {fields.length > 1 && (
          <Trash2
            height="40px"
            aria-label="Eliminar pedido"
            data-testid={`delete-order-${idx}`}
            onClick={() => {
              if (disabled) return;
              if (fields.length > 1) {
                remove(idx);
              }
            }}
            cursor={disabled || fields?.length <= 1 ? "not-allowed" : "pointer"}
          />
        )}
      </GridItem>
    </Grid>
  );
};
